import React, { forwardRef } from 'react';
import FormGroup from '../../common/FormGroup';

export interface KeySearchKeysFieldProps {
  label: string;
  helpContent?: React.ReactNode;
  error?: unknown;
  name: string;
  placeholder?: string;
  defaultValue?: string;
  onChange: React.ChangeEventHandler<HTMLTextAreaElement>;
  onSearch: () => void;
  searchDisabled?: boolean;
  searchButtonLabel: string;
  rows?: number;
}

const KeySearchKeysField = forwardRef<HTMLTextAreaElement, KeySearchKeysFieldProps>(
function KeySearchKeysField(
  {
    label,
    helpContent,
    error,
    name,
    placeholder,
    defaultValue,
    onChange,
    onSearch,
    searchDisabled,
    searchButtonLabel,
    rows = 5,
  },
  ref
) {
  return (
    <FormGroup
      error={error}
      extraRowClasses="align-items-start"
      helpContent={helpContent}
    >
      <textarea
        ref={ref}
        aria-label={label}
        name={name}
        placeholder={placeholder}
        className="form-control monospace"
        rows={rows}
        defaultValue={defaultValue}
        onChange={onChange}
        data-lpignore="true"
        autoComplete="off"
      />
      <button
        type="button"
        onClick={onSearch}
        className="btn btn-primary mt-2"
        disabled={searchDisabled}
      >
        {searchButtonLabel}
      </button>
    </FormGroup>
  );
});

export default KeySearchKeysField;
